import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListingComponentComponent } from './listing-component.component';
import { SelectCustomerListingComponent } from './select-customer-listing/select-customer-listing.component';



@NgModule({
  declarations: [
    ListingComponentComponent,
    SelectCustomerListingComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ListingComponentComponent,
    SelectCustomerListingComponent
  ]
})
export class ListingModuleModule { }
